// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"581e79f8","85":"ff438eec","139":"d7d54ed7","149":"c05e31dd","181":"77eb5155","369":"40d479fb","519":"7d43962e","681":"3e835b34","696":"02ada05e","780":"3fbab7a2","824":"47ccfd81","960":"4ad22804"}[chunkId] + ".chunk.js";
};